<template>
  <section class="section header-section" ref="headerSection">
    <div class="inner-container">
      <div class="shape">
        <div
          v-for="(n, index) in 75"
          :key="index"
          :class="[
            'shape-container--' + n + ' shape-animation',
            greaterThan50(n) ? 'hide' : '',
          ]"
        >
          <div class="random-shape"></div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col intro-left">
            <img
              class="person"
              src="@/assets/img/background/person-with-circle.png"
            />
            <div class="top-box">
              <h1 class="display-4">Learn to match outfits</h1>
              <p class="lead">
                <i>Develop personal style through experimentation</i>
              </p>
              <form-horizontal></form-horizontal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FormHorizontal from "@/components/landing/FormHorizontal";
export default {
  components: {
    FormHorizontal,
  },

  data() {
    return {
      shapes: [],
    };
  },

  methods: {
    greaterThan50(n) {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.3/css/font-awesome.css);

.header-section {
  margin-bottom: 50px !important;
  background: linear-gradient(to right, #fafafa 35%, #f8d1b2 35%);

  @include for-tablet-portrait-up {
    background: linear-gradient(to right, #fafafa 45%, #f8d1b2 45%);
  }

  .intro-left {
    padding-top: 230px;
    // max-width: 60%;
    max-width: 100%;

    @include for-tablet-portrait-up {
      max-width: 100%;
      padding-top: 340px;
    }

    .top-box {
      margin-top: -50px;
      margin-bottom: 220px;
      position: relative;
      z-index: 1;
    }

    .display-4 {
      font-size: 2.2rem;
      color: $primary-blue;
      margin-bottom: 0px;
      font-weight: 400;
      font-family: "Josefin Slab", serif;

      @include for-tablet-portrait-up {
        font-size: 2.8rem;
      }
    }

    .lead {
      color: $grey1;
      font-size: 0.9rem;
      margin-bottom: 40px;

      @include for-tablet-portrait-up {
        font-size: 1rem;
        margin-bottom: 60px;
      }
    }
  }

  img.person {
    position: absolute;
    bottom: 0px;
    right: auto;
    // left: 40%;
    height: auto;
    width: 500px;
    opacity: 0.3 !important;
    // visibility: hidden;

    @include for-sm-phone-only {
      opacity: 0.5 !important;
      left: 30%;
    }

    // @media only screen and (max-device-width: 320px) {
    //   opacity: 100%;
    //   left: 30%;
    // }

    @include for-phone-only {
      opacity: 0.4 !important;
      left: 30%;
    }

    @include for-tablet-portrait-up {
      opacity: 1 !important;
      left: auto;
      right: -10%;
      // visibility: visible;
    }

    @include for-tablet-landscape-up {
      opacity: 1 !important;
      left: auto;
      right: 0%;
    }

    @include for-desktop-up {
      opacity: 1 !important;
      left: auto;
      right: 0;
    }
  }

  .inner-container {
    overflow: hidden;
    position: relative;
  }

  .shape {
    z-index: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    opacity: 0.7;

    .hide {
      visibility: hidden !important;
      @include for-tablet-portrait-up {
        visibility: visible !important;
      }
    }
  }

  .random-shape:after {
    font-family: FontAwesome;
    content: "\f04d";
  }

  $circle-size: 100px;
  $colors: #45ffdc, #ffef96, #ff94a1, #cda1ff, #31b4ff, #4800c0, #9300c9;
  $shapes: "\f111", "\f10c", "\f068", "\f22d", "\f077", "\f04b", "\f067",
    "\f04d";
  $shape-count: 80;

  @for $i from 1 through $shape-count {
    $shape-size: 0.7 + random(5);

    $rotation: random(360);
    $speed: 40 + random(30);
    $color-key: random(length($colors));
    $shape-color: nth($colors, $color-key);
    $shape-key: random(length($shapes));
    $shape-type: nth($shapes, $shape-key);
    $text: random(10);

    @keyframes shape-#{$i} {
      0% {
        transform: translate3d(0, 0, 0) rotate(#{$rotation + 0}deg);
      }
      100% {
        transform: translate3d(0, 0, 0) rotate(#{$rotation + 360}deg);
      }
    }

    .shape-container--#{$i} {
      animation: shape-#{$i} #{$speed}s linear infinite;

      .random-shape:after {
        margin: #{$shape-size}rem;
        color: $shape-color;
        font-size: #{$shape-size * 0.2}rem;
        content: $shape-type;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/HeaderSection.vue